export default "__VITE_ASSET__B6bnhM1C__"